import { Link } from 'react-router-dom'
import { RefreshCw, Upload, UserCheck, UserPlus } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import {
  FilterBar,
  FilterSearch,
  FilterSelect,
  PageToolbar,
  SegmentTabs,
  ToolbarControlsGroup,
  ToolbarIconButton,
} from '@/components/ui/page-toolbar'
import type { ClientesFilter } from '@/hooks/useClientesAgradaPage'

type Props = {
  filter: ClientesFilter
  setFilter: (v: ClientesFilter) => void
  search: string
  setSearch: (v: string) => void
  loading: boolean
  onReload: () => void
  canImport: boolean
  importing: boolean
  onImportClick: () => void
}

export function ClientesAgradaTopbar({
  filter,
  setFilter,
  search,
  setSearch,
  loading,
  onReload,
  canImport,
  importing,
  onImportClick,
}: Props) {
  return (
    <PageToolbar
      navigation={
        <SegmentTabs
          value='lista'
          onChange={() => undefined}
          tabs={[{ id: 'lista', label: 'Clientes ativos', icon: UserCheck }]}
          ariaLabel='Clientes Agrada'
        />
      }
      controls={
        <ToolbarControlsGroup>
          {canImport && (
            <Link to='/clientes/novo'>
              <Button type='button' size='sm'>
                <UserPlus size={14} />
                Cadastrar cliente
              </Button>
            </Link>
          )}
          {canImport && (
            <Button
              type='button'
              variant='secondary'
              size='sm'
              disabled={importing}
              onClick={onImportClick}
            >
              <Upload size={14} />
              {importing ? 'Importando…' : 'Importar CSV'}
            </Button>
          )}
          <ToolbarIconButton
            active={loading}
            onClick={onReload}
            title='Atualizar'
            aria-label='Atualizar'
          >
            <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
          </ToolbarIconButton>
        </ToolbarControlsGroup>
      }
      filters={
        <FilterBar>
          <FilterSearch
            value={search}
            onChange={setSearch}
            placeholder='Buscar por nome, CNPJ ou e-mail…'
          />
          <FilterSelect
            value={filter}
            onChange={(v) => setFilter(v as ClientesFilter)}
            ariaLabel='Filtrar clientes'
          >
            <option value='todos'>Todos os clientes</option>
            <option value='novos_30d'>Novos (30 dias)</option>
            <option value='importados'>Legado / importados</option>
            <option value='com_projeto'>Com projeto financeiro</option>
          </FilterSelect>
        </FilterBar>
      }
    />
  )
}
